// Lo que cada persona ya resolvió en la pantalla «Prompts»: si ocultó «Cómo funciona» y los dos
// pasos de «Prepara tu IA» que se marcan a mano. Es comodidad de quien mira, no estado de la agencia:
// vive en el navegador, por usuario, y si no hay almacenamiento (ventana privada, sitio bloqueado) la
// pantalla arranca como la primera vez — nunca falla por eso.

const KEY_PREFIX = 'agp-prefs-';

export const DEFAULT_PREFS = Object.freeze({howHidden: false, aiConnected: false, instructionPasted: false});

function keyFor(userId) {
    return `${KEY_PREFIX}${userId || 'anon'}`;
}

export function readPrefs(userId) {
    try {
        const raw = window.localStorage.getItem(keyFor(userId));
        const stored = raw ? JSON.parse(raw) : {};
        return {
            howHidden: stored.howHidden === true,
            aiConnected: stored.aiConnected === true,
            instructionPasted: stored.instructionPasted === true,
        };
    } catch (e) {
        return {...DEFAULT_PREFS};
    }
}

export function writePrefs(userId, prefs) {
    try {
        window.localStorage.setItem(keyFor(userId), JSON.stringify(prefs));
    } catch (e) {
        // Sin almacenamiento la preferencia dura lo que dura la pantalla.
    }
}
